export default {"src":"/_next/static/media/brush_40.ba237e1a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};